<template>
	<div
		v-if="packageRelations.length > 0"
		class="grid lg:gap-y-10 lg:mb-10 gap-y-5 mb-5"
	>
		<ProductsRow
			v-for="{ Code, Items, Name } in packageRelations"
			:key="Code"
			:current-product="product as ProductItem"
			:products="Items || []"
			:title="Name"
			:is-item-blocked="isItemBlocked"
		/>
	</div>
</template>

<script setup lang="ts">
import type {
	Product,
	ProductItem,
	SimplifiedProductRelations
} from "@nwt/norce-pwa/dist/runtime/types/api/product/product";
import { ProductPrefix } from "~/utils/constants";
import { computed, ref, watch } from "vue";
import ProductsRow from "./ProductsRow.vue";

interface Props {
	product: Product;
	/** Per-item purchase rule for the package button; see ProductsRow. */
	isItemBlocked?: (product: ProductItem) => boolean;
}

const { product, isItemBlocked } = defineProps<Props>();

const packageRelations = ref<SimplifiedProductRelations[]>([]);

const { relations } = storeToRefs(useProductStore());

const productRelations = computed(() => {
	return (
		(relations.value as SimplifiedProductRelations[]).filter((relation) =>
			relation.Code?.includes(ProductPrefix.PACKAGE_PRODUCT)
		) || []
	);
});

watch(
	productRelations,
	(newRelations) => {
		packageRelations.value = newRelations;
	},
	{ immediate: true }
);
</script>
